import app from 'app';

app.namespace.Model.TokenModel = Backbone.Model.extend({
  '?': 'TokenModel',

  /* model properties, used to get array of model required keys*/
  defaults: {
    begin: null,
    duration: null,
    order: null,
    string: null,
    type: null,
  },

  /**
   * @static
   * @param obj
   * @return {*}
   */
  strip: function (obj) {
    obj = _.pick(
      obj,
      _.keys(app.namespace.Model.TokenModel.prototype.defaults)
    );

    _.map(obj, function (value, key) {
      if (/^[_|$]/.test(key)) {
        obj[key] = null;
        delete obj[key];
      }
    });

    return obj;
  },
});

app.namespace.Collection.TokenCollection = Backbone.Collection.extend({
  '?': 'TokenCollection',
  model: app.namespace.Model.TokenModel,

  initialize: function (options) {
    this.task = options.task;
  },

  comparatorFields: [
    {
      asc: true,
      from: function (model) {
        return model.get('order');
      },
    },
  ],

  parse: function (raw) {
    if (!_.isEmpty(raw.tokens)) {
      _.each(raw.tokens, (token, i, tokens) => {
        if (0 === i) {
          token.duration = app.sfp(
            token.duration + this.task.get('defaultPreNarrationTime')
          );
        } else if (i === tokens.length - 1) {
          token.duration = app.sfp(
            token.duration + this.task.get('defaultPostNarrationTime')
          );
        }
      });
    }

    return raw.tokens;
  },

  getTimeBetweenTokens: function (tokenPosition1, tokenPosition2) {
    if (!tokenPosition2) {
      tokenPosition2 = this.last().get('order');
    }

    return _.reduce(
      this.models,
      function (memo, token) {
        if (
          token.get('order') >= tokenPosition1 &&
          token.get('order') <= tokenPosition2
        ) {
          return memo + token.get('duration');
        } else {
          return memo;
        }
      },
      0
    );
  },

  getAssetTimeTokens: function (assetModel, assetTime, lastPositonArg) {
    const I = this.models.length;
    let i = 0;
    let state = {
      assetToken: _.isNumeric(lastPositonArg)
        ? lastPositonArg
        : assetModel.get('tokenOrderPosition'),
      time: 0,
    };

    for (; i < I && app.sfp(state.time) <= assetTime; i++) {
      if (i >= state.assetToken) {
        state.time += this.models[i].get('duration');
      }
    }
    --i;

    state = null;
    return i;
  },

  getTime: function () {
    return _.reduce(
      this.models,
      function (memo, token) {
        return memo + token.get('duration');
      },
      0
    );
  },
});
